// extracted by mini-css-extract-plugin
export default {"editor":"QuillEditor_editor__Eg7t-","viewer":"QuillEditor_viewer__wSTfv"};